import React, { useMemo } from 'react';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import CustomizationBlockItem from './CustomizationBlockItem';
import { useUser } from '../../../../redux/reducer/user';
import { isNumber } from 'lodash';

const CustomizationBlock = React.forwardRef(function CustomizationBlock(
  { list, filter, callbacks, setFilter, customState, customCallbacks, isBeauties },
  ref,
) {
  const { profile } = useUser();

  const formattedArray = useMemo(() => {
    const currentArr = customState === 'beauties' ? list.array : list?.[filter]?.array ?? [];

    const filteredArr = currentArr.filter((item) => {
      const isHave = profile?.items?.some(({ id }) => id === item?.id);
      return customState === 'beauties'
        ? isHave || !item?.buy_blocked
        : isHave || (!item?.buy_blocked && !isNumber(item?.product_id));
    });

    const [newItems, oldItems] = filteredArr
      .reduce(
        (acc, item) => {
          acc[item?.is_new ? 0 : 1].push(item);
          return acc;
        },
        [[], []],
      )
      .map((arr) => arr.sort((a, b) => a?.cost - b?.cost));

    return [...newItems, ...oldItems].sort((a, b) => {
      const insideProfileA = profile?.items?.find(({ id }) => id === a?.id);
      const insideProfileB = profile?.items?.find(({ id }) => id === b?.id);

      if (!insideProfileA) return 1;
      if (!insideProfileB) return -1;

      const { is_equipped: isEquippedA, is_default: isDefaultA, image: imageA } = insideProfileA;
      const { is_equipped: isEquippedB, is_default: isDefaultB, image: imageB } = insideProfileB;
      if (isEquippedA) return -1;
      if (isEquippedB) return 1;

      if (isDefaultA && !imageA) return -1;
      if (isDefaultB && !imageB) return 1;

      return 0;
    });
  }, [list, filter, profile?.items, customState]);

  const title = customState === 'beauties' ? list?.title : list?.[filter]?.title;

  const onButtonClick = () => {
    setFilter(null);
    customCallbacks?.();
  };
  return (
    <div className={'customization__block'}>
      <div className={'customization__block-header'}>
        <CustomButton
          className={'customization__block-back button_back button_icon button_transparent'}
          icon={'buttons/back_customization'}
          onClick={onButtonClick}
        />
        <div className={'customization__block-title'}>{title}</div>
      </div>
      <div className={'customization__lists'}>
        <div className={`customization__list`}>
          {formattedArray.map((el, key) => (
            <CustomizationBlockItem
              key={`item-${key}`}
              callbacks={callbacks}
              item={el}
              customState={customState}
              index={key}
              filter={filter}
              isBeauties={isBeauties}
              {...el}
            />
          ))}
        </div>
      </div>
    </div>
  );
});
export default CustomizationBlock;
CustomizationBlock.propTypes = {};
